import React, { useState } from "react";
import { getEntities } from "../../API";
import { useNavigate, useLoaderData } from "react-router-dom";

export async function loader() {
  return getEntities("users");
}

function Users() {
  const users = useLoaderData();
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();

  const userClick = (id) => {
    navigate(`${id}`);
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchText(searchTerm);

    const filteredItems = users.filter(
      (user) =>
        user.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.lastname.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filteredItems);
  };
  return (
    <div className="flex-grow-1 p-4 overflow-auto">
      <div className="container">
        <div className="row">
          <div className="col-10">
            <input
              className="form-control me-2"
              type="search"
              value={searchText}
              onChange={handleSearch}
              placeholder="Search"
              aria-label="Search"
            />
          </div>
          <div className="col">
            <button
              className="btn btn-outline-success"
              onClick={() => {
                navigate("new");
              }}
            >
              New
            </button>
          </div>
        </div>
      </div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user) => (
            <tr role="button" key={user.id} onClick={() => userClick(user.id)}>
              <td>{user.firstname}</td>
              <td>{user.lastname}</td>
              <td>{user.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Users;
